import { z } from 'zod'

export const StageDetailFormEntitySchema = z.object({
  id: z.number(),
  name: z.string().min(1, { message: '1文字以上入力必須' }),
  priority: z.number().min(1, { message: '1以上の数値を入力して下さい' }),
})

export const BulkUpdateUserCancelDetailsFormEntitySchema = z.object({
  details: z.array(StageDetailFormEntitySchema),
})
export type BulkUpdateUserCancelDetailsFormEntity = z.infer<
  typeof BulkUpdateUserCancelDetailsFormEntitySchema
>

const StageFormEntitySchema = z.object({
  id: z.number(),
  details: z.array(StageDetailFormEntitySchema),
})
export const BulkUpdateUserStageDetailsFormEntitySchema = z.object({
  stages: z.array(StageFormEntitySchema),
})
export type BulkUpdateUserStageDetailsFormEntity = z.infer<
  typeof BulkUpdateUserStageDetailsFormEntitySchema
>
